import * as React from "react";
import { useSearchParams } from "react-router-dom";
import VerifyRegistration from "@route-planner/components/VerifyRegistration";

const Component = (props) => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  return <VerifyRegistration code={code} />;
};

const page = {
  routeProps: {
    path: "VerifyAlertsRegistration",
    component: Component,
  },
  name: "Email Verification",
  label: "Email Verification",
  title: "Email Verification",
  showOnMenu: false,
};

export default page;
